import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    const url = window.location.href;
    const title = document.title;
    trackPageView(url, title);
  }, [location]);

  return null; // This component doesn't render anything
};

export default AnalyticsTracker; 